(function () {
  'use strict';

  var labels = {
    de: 'In den Warenkorb',
    en: 'Add to cart',
    fr: 'Ajouter au panier',
    it: 'Aggiungi al carrello'
  };

  var buttonSelector = '.product-form__submit, product-form button[type="submit"], .sn-product__cta';

  function getLocale() {
    var match = window.location.pathname.match(/^\/(de|fr|it)(?:\/|$)/i);
    if (match) return match[1].toLowerCase();
    return (document.documentElement.lang || 'de').toLowerCase().slice(0, 2);
  }

  function createSpinner() {
    var spinner = document.createElement('div');
    spinner.className = 'loading-overlay__spinner hidden';
    spinner.innerHTML = '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';
    return spinner;
  }

  function ensureButton(button) {
    if (!button || !button.matches(buttonSelector)) return;

    var soldOutMessage = button.querySelector('.sold-out-message');
    var label = button.querySelector(':scope > span:not(.sold-out-message)');

    if (!label && !button.disabled && button.getAttribute('aria-disabled') !== 'true') {
      var directText = '';
      Array.prototype.slice.call(button.childNodes).forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()) {
          if (!directText) directText = node.nodeValue.trim();
          node.remove();
        }
      });

      label = document.createElement('span');
      label.textContent = directText || (window.variantStrings && window.variantStrings.addToCart) || labels[getLocale()] || labels.en;
      button.insertBefore(label, button.firstChild);
    }

    if (!button.querySelector('.loading-overlay__spinner')) {
      button.appendChild(createSpinner());
    }

    if (soldOutMessage && button.disabled) {
      soldOutMessage.classList.remove('hidden');
    }
  }

  function run(root) {
    if (!root) return;
    if (root.nodeType === Node.ELEMENT_NODE && root.matches && root.matches(buttonSelector)) {
      ensureButton(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll(buttonSelector).forEach(ensureButton);
    }
  }

  function isCartAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;

    var action = form.getAttribute('action') || form.action || '';
    return /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(action);
  }

  function getSubmitButton(event, form) {
    return event.submitter || form.querySelector('button[type="submit"], input[type="submit"]');
  }

  function setLoading(button, loading) {
    if (!button) return;

    var spinner = button.querySelector && button.querySelector('.loading-overlay__spinner');
    if (loading) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
      return;
    }

    button.removeAttribute('aria-disabled');
    button.classList.remove('loading');
    if (spinner) spinner.classList.add('hidden');
  }

  function decodeMessage(message) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = String(message || '');
    return textarea.value;
  }

  function showError(form, message) {
    var error = form.querySelector('[data-sn-cart-error]');

    if (!message) {
      if (error) error.setAttribute('hidden', '');
      return;
    }

    if (!error) {
      error = document.createElement('small');
      error.className = 'product-form__error-message';
      error.setAttribute('data-sn-cart-error', '');
      error.setAttribute('role', 'alert');
      form.appendChild(error);
    }

    error.textContent = decodeMessage(message);
    error.removeAttribute('hidden');
  }

  var variantRequests = {};

  function getProductJsonUrl(form) {
    var productUrl = form.getAttribute('data-product-url');
    var productContainer = form.closest('[data-product-url]');

    if (!productUrl && productContainer) productUrl = productContainer.getAttribute('data-product-url');

    if (!productUrl) {
      var productLink = form.closest('.sn-product, .card-wrapper, .product')
        && form.closest('.sn-product, .card-wrapper, .product').querySelector('a[href*="/products/"]');
      if (productLink) productUrl = productLink.getAttribute('href');
    }

    if (!productUrl && /\/products\//.test(window.location.pathname)) {
      productUrl = window.location.pathname;
    }

    if (!productUrl) return null;

    var url = new URL(productUrl, window.location.origin);
    if (!/\/products\//.test(url.pathname)) return null;

    url.pathname = url.pathname.replace(/\/$/, '').replace(/\.js$/, '') + '.js';
    url.search = '';
    url.hash = '';
    return url.toString();
  }

  function ensureVariantId(form) {
    var input = form.querySelector('[name="id"]');
    if (input && input.value) {
      input.disabled = false;
      form.setAttribute('data-sn-resolved-variant', input.value);
      return Promise.resolve(input.value);
    }

    var productJsonUrl = getProductJsonUrl(form);
    if (!productJsonUrl) {
      return Promise.reject(new Error('Unable to determine the product variant.'));
    }

    if (!variantRequests[productJsonUrl]) {
      variantRequests[productJsonUrl] = fetch(productJsonUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load product data.');
          return response.json();
        })
        .catch(function (error) {
          delete variantRequests[productJsonUrl];
          throw error;
        });
    }

    return variantRequests[productJsonUrl].then(function (product) {
      var variants = product && product.variants ? product.variants : [];
      var variant = variants.find(function (candidate) { return candidate.available; }) || variants[0];

      if (!variant || !variant.id) {
        throw new Error('No purchasable product variant is available.');
      }

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'id';
        form.appendChild(input);
      }

      input.disabled = false;
      input.value = String(variant.id);
      input.setAttribute('value', String(variant.id));
      form.setAttribute('data-sn-resolved-variant', input.value);
      return input.value;
    });
  }

  function getCartSectionIds(cart) {
    if (!cart || typeof cart.getSectionsToRender !== 'function') return [];

    return cart.getSectionsToRender()
      .map(function (section) { return section.section || section.id; })
      .filter(Boolean);
  }

  function hydrateCartSections(cart, response) {
    var sectionIds = getCartSectionIds(cart);
    var hasEverySection = sectionIds.length > 0
      && response.sections
      && sectionIds.every(function (sectionId) { return response.sections[sectionId]; });

    if (hasEverySection) return Promise.resolve(response);
    if (!sectionIds.length) return Promise.reject(new Error('No cart sections are configured.'));

    var refreshConfig = typeof fetchConfig === 'function'
      ? fetchConfig()
      : {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        };

    refreshConfig.cache = 'no-store';
    refreshConfig.body = JSON.stringify({
      sections: sectionIds,
      sections_url: window.location.pathname
    });

    return fetch(getCartUpdateUrl(), refreshConfig)
      .then(function (cartResponse) {
        if (!cartResponse.ok) throw new Error('Unable to refresh the cart drawer.');
        return cartResponse.json();
      })
      .then(function (cartState) {
        response.item_count = cartState.item_count;

        if (cartState.sections) {
          response.sections = cartState.sections;
          return response;
        }

        // Some translated Shopify routes omit sections from cart/update even
        // when requested. The POST above serializes the cart state; rendering
        // the sections immediately afterward now returns the committed cart.
        return fetchRenderedCartSections(sectionIds, cartState.item_count).then(function (sections) {
          response.sections = sections;
          return response;
        });
      });
  }

  function getCartUrl() {
    if (window.routes && window.routes.cart_url) return window.routes.cart_url;

    var locale = getLocale();
    return locale === 'de' ? '/cart' : '/' + locale + '/cart';
  }

  function getCartUpdateUrl() {
    if (window.routes && window.routes.cart_update_url) return window.routes.cart_update_url;

    var locale = getLocale();
    return locale === 'de' ? '/cart/update.js' : '/' + locale + '/cart/update.js';
  }

  function fetchRenderedCartSections(sectionIds, expectedItemCount, attempt) {
    attempt = attempt || 0;
    var delay = Math.min(300 + (attempt * 200), 700);

    return new Promise(function (resolve) {
      setTimeout(resolve, delay);
    })
      .then(function () {
        var cartPageUrl = new URL(getCartUrl(), window.location.origin);
        cartPageUrl.searchParams.set('_sn_cart_refresh', String(Date.now()) + '-' + attempt);

        return fetch(cartPageUrl.toString(), {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            Accept: 'text/html',
            'Cache-Control': 'no-cache'
          }
        });
      })
      .then(function (cartPageResponse) {
        if (!cartPageResponse.ok) throw new Error('Unable to load the refreshed cart page.');
        return cartPageResponse.text();
      })
      .then(function (cartPageHtml) {
        var parsed = new DOMParser().parseFromString(cartPageHtml, 'text/html');
        var drawer = parsed.querySelector('cart-drawer');
        var iconBubble = parsed.querySelector('#cart-icon-bubble');

        if (!drawer || !iconBubble) {
          throw new Error('The refreshed cart page is missing drawer markup.');
        }

        var countElement = drawer.querySelector('.sn-cart-count');
        var renderedCount = countElement ? parseInt(countElement.textContent, 10) || 0 : 0;
        var hasExpectedCount = expectedItemCount === null
          || expectedItemCount === undefined
          || renderedCount === expectedItemCount;

        if (!hasExpectedCount && attempt < 3) {
          return fetchRenderedCartSections(sectionIds, expectedItemCount, attempt + 1);
        }

        if (!hasExpectedCount) {
          throw new Error('The refreshed cart page is still stale.');
        }

        return {
          'cart-drawer': drawer.outerHTML,
          'cart-icon-bubble': '<div class="shopify-section">' + iconBubble.outerHTML + '</div>'
        };
      });
  }

  function submitCartForm(event) {
    if (!isCartAddForm(event.target)) return;

    var form = event.target;
    var button = getSubmitButton(event, form);
    var itemAdded = false;
    var nativeProductForm = form.closest('product-form');

    // Italian and French use the same native Shopify product form as German.
    // Their translation layer clears the hidden variant value, so restore only
    // that value and then let the proven native handler own the submission.
    if (nativeProductForm) {
      useGermanCartEndpoints();
      var nativeVariantInput = form.querySelector('[name="id"]');
      var resolvedVariant = form.getAttribute('data-sn-resolved-variant');

      if (resolvedVariant && nativeVariantInput) {
        nativeVariantInput.disabled = false;
        nativeVariantInput.value = resolvedVariant;
        nativeVariantInput.setAttribute('value', resolvedVariant);
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!button || button.disabled || form.getAttribute('data-sn-cart-submitting') === 'true') return;

      form.setAttribute('data-sn-cart-submitting', 'true');
      showError(form, false);
      setLoading(button, true);

      ensureVariantId(form)
        .then(function () {
          form.removeAttribute('data-sn-cart-submitting');
          setLoading(button, false);
          form.requestSubmit(button);
        })
        .catch(function (error) {
          console.error(error);
          form.removeAttribute('data-sn-cart-submitting');
          setLoading(button, false);
          showError(form, (window.cartStrings && window.cartStrings.error) || 'Unable to add this item to the cart.');
        });
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    if (form.getAttribute('data-sn-cart-submitting') === 'true') return;

    form.setAttribute('data-sn-cart-submitting', 'true');
    showError(form, false);
    setLoading(button, true);

    ensureVariantId(form)
      .then(function () {
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var formData = new FormData(form);

        if (cart && typeof cart.getSectionsToRender === 'function') {
          var sectionIds = getCartSectionIds(cart);
          formData.set('sections', sectionIds.join(','));
          formData.set('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }

        var config = typeof fetchConfig === 'function'
          ? fetchConfig('javascript')
          : { method: 'POST', headers: { Accept: 'application/json' } };

        config.headers = config.headers || {};
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        var addUrl = (window.routes && window.routes.cart_add_url) || form.action;
        return fetch(addUrl, config);
      })
      .then(function (response) {
        if (!response) return null;
        return response.json().then(function (data) {
          if (!response.ok && !data.status) data.status = response.status;
          return data;
        });
      })
      .then(function (response) {
        if (!response) return;

        if (response.status) {
          showError(form, response.description || (window.cartStrings && window.cartStrings.error) || 'Unable to add this item to the cart.');
          return;
        }

        itemAdded = true;
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          return hydrateCartSections(cart, response).then(function (hydratedResponse) {
            cart.renderContents(hydratedResponse);
          });
        }

        window.location.assign(getCartUrl());
      })
      .catch(function (error) {
        console.error(error);

        // The add request may have succeeded even if a translated section failed
        // to render. In that case, take the customer to the cart instead of
        // showing a false add-to-cart error or inviting duplicate clicks.
        if (itemAdded) {
          window.location.assign(getCartUrl());
          return;
        }

        showError(form, (window.cartStrings && window.cartStrings.error) || 'Unable to add this item to the cart.');
      })
      .finally(function () {
        form.removeAttribute('data-sn-cart-submitting');
        setLoading(button, false);
      });
  }

  function useGermanCartEndpoints() {
    if (!window.routes) return;

    // German's root cart endpoints are the stable implementation. Shopify's
    // sections_url still controls the rendered language, so Italian and French
    // keep their localized drawer content while sharing the same cart backend.
    window.routes.cart_add_url = '/cart/add';
    window.routes.cart_change_url = '/cart/change';
    window.routes.cart_update_url = '/cart/update';
  }

  function start() {
    useGermanCartEndpoints();
    run(document);
    document.addEventListener('submit', submitCartForm, true);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          if (mutation.target && mutation.target.nodeType === Node.ELEMENT_NODE && mutation.target.matches && mutation.target.matches(buttonSelector)) {
            ensureButton(mutation.target);
          }
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === Node.ELEMENT_NODE) run(node);
          });
        }
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
